module.exports = __webpack_public_path__ + "static/img/8.dbc2f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/8.png
// module id = vuzJ
// module chunks = 0